import React, { ReactNode, useState } from "react";
import { Select, Divider, Input, Button } from "antd";
import "@Styles/main.scss";

interface IProps {
    onChange?: (value: string, option?: string) => void;
    label?: ReactNode;
    className?: string;
    value?: string;
}

const SpecialtySelect: React.FC<IProps> = ({ value, onChange, label, className }: IProps) => {
    const [specialtyOptions, setSpecialtyOptions] = useState<string[]>([
        "Anaesthetics",
        "Cardiothoracic",
        "Chiropractic",
        "Colorectal",
        "Cosmetic",
        "Dentistry",
        "Dermatology",
        "Education",
        "Endoscopy",
        "General Surgery",
        "Healthcare",
        "Not Applicable",
        "Nursing",
        "Obstetrics and Gynaecology",
        "Oncology",
        "Paediatric",
        "Psychiatry",
        "Radiology",
        "Training and Simulation",
        "Trauma and Orthopaedic",
        "Upper Gastrointestinal",
        "Urology",
        "Vascular",
    ]);
    const [customSpecialtyOption, setCustomSpecialtyOption] = useState<string>("");

    const { Option } = Select;

    const onUpdateCustomSpecialtyOpt = (e: React.FormEvent<HTMLInputElement>) => {
        const target = e.target as HTMLButtonElement;
        setCustomSpecialtyOption(target.value);
        onChange?.("specialty", target.value);
    };

    const addNewSpecialtyOpt = () => {
        const currentOpts = [...specialtyOptions, customSpecialtyOption];
        setSpecialtyOptions(currentOpts);
        setCustomSpecialtyOption("");
        onChange?.("specialty", customSpecialtyOption);
    };

    return (
        <Select
            showSearch
            value={value}
            placeholder="Select a specialty"
            onChange={(e) => onChange?.(e)}
            id="specialty"
            dropdownRender={(menu) => (
                <div>
                    {menu}
                    <Divider style={{ margin: "4px 0" }} />
                    <div style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}>
                        <Input value={customSpecialtyOption} onChange={onUpdateCustomSpecialtyOpt} />
                        <Button className="secondary" onClick={addNewSpecialtyOpt}>
                            Add option
                        </Button>
                    </div>
                </div>
            )}
        >
            {specialtyOptions.map((option) => (
                <Option key={option} value={option}>
                    {option}
                </Option>
            ))}
        </Select>
    );
};

export default SpecialtySelect;
